import { useRef, useState } from "react";
import styled from "styled-components";
import ActionIcon from "../../custom/ActionIcon";
import moment from "moment";
import useUser from "../../../customHooks/useUser";
import useSWR from "swr";
import { IFFM } from "../../../globals/interfaces";
import { customFetcher, extractReactTableData, fileDownload } from "../../../utils";
import VirtualTable from "../../custom/VirtualTable";
import _ from "lodash";
import DateRange from "../../custom/DateRange";

interface CustomFFM extends IFFM {
    duration: number;
}

export default function FlightDetail() {

    const { user } = useUser();
    const [startDate, setStartDate] = useState(moment().add(-1, 'week').format('YYYY-MM-DD'));
    const [endDate, setEndDate] = useState(moment().format('YYYY-MM-DD'));
    const s_destination = _.get(user, 's_unit', '').substring(1, 4);
    const queryKey = s_destination && moment(startDate).isValid() && moment(endDate).isValid() ?
        `/transfers-analytics/flight-detail?d_start_date=${startDate}&d_end_date=${endDate}&s_destination=${s_destination}` : null;
    const {
        data
    } = useSWR(queryKey, customFetcher<IFFM>);

    const tableRef = useRef();
    const downloadData = () => {
        const data = extractReactTableData(tableRef, ['index', 's_flight_id'], [{
            name: 'Date',
            key: 'd_arrival_date',
            date: true
        }, {
            name: 'Flight',
            key: 's_flight_number'
        }, {
            name: 'Departed',
            key: 't_created',
            time: true
        }, {
            name: 'Arrival',
            key: 't_actual_arrival',
            time: true
        }, {
            name: 'Duration (m)',
            key: 'duration'
        }, {
            name: 'Created',
            key: 't_created',
            datetime: true
        }]);
        if (data && data.length) {
            fileDownload(data, `flight-detail-${startDate}-${endDate}`);
        }
    }

    return (
        <div>
            <FlexContainer>
                <DateRange
                    startDate={startDate}
                    setStartDate={setStartDate}
                    endDate={endDate}
                    setEndDate={setEndDate}
                    increment={'week'}
                />
                <ActionIcon
                    type={'download'}
                    onClick={downloadData}
                />
            </FlexContainer>
            <VirtualTable<CustomFFM>
                data={data}
                reactTableRef={tableRef}
                mapping={[{
                    name: 'Date',
                    value: 'd_arrival_date',
                    utc: true,
                    date: true
                }, {
                    name: 'Flight',
                    value: 's_flight_number'
                }, {
                    name: 'Departed',
                    value: 't_created',
                    utc: true,
                    time: true
                }, {
                    name: 'Arrival',
                    value: 't_actual_arrival',
                    utc: true,
                    time: true
                }, {
                    name: 'Duration (m)',
                    value: 'duration',
                    number: true
                }, {
                    name: 'Created',
                    value: 't_created',
                    datetime: true,
                    utc: true
                }]}
            />
        </div>
    );
}

const FlexContainer = styled.div`
    display: flex;
    justify-content: space-between;
`;